import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useShift } from '../context/ShiftContext';
import { getShiftTheme } from '../pages/shift/ShiftChrome';

export default function ShiftAuthGate({ children }) {
  const { status, needsShiftPick, isOwner } = useShift();
  const loc = useLocation();

  if (status === 'checking') {
    return (
      <div className="shift-root" data-theme={getShiftTheme()}>
        <div className="shift-phone" style={{ alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ color: 'var(--text3)', padding: 40 }}>載入中…</div>
        </div>
      </div>
    );
  }
  if (status === 'anon') {
    return <Navigate to="/shift/login" replace state={{ from: loc.pathname }} />;
  }
  // 員工／主管須先選班；選班頁本身放行
  if (needsShiftPick && !isOwner && !loc.pathname.endsWith('/pick')) {
    return <Navigate to="/shift/pick" replace />;
  }
  if (!needsShiftPick && loc.pathname.endsWith('/pick')) {
    return <Navigate to="/shift/home" replace />;
  }
  return children;
}
